import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../Components/Header/Header";
import { apiCallAmbassadorCancel, apiCallGetActivatedPlan, apiCallGetSubscriptionPlanHistory, apiCallSubscriptionUpdatePlanStatus, apiUpgradeUserSubscription } from "../../Core/Apicall";
import {
  setLoadingFalse,
  setLoadingTrue,
} from "../../Config/Actions/loadingActions";
import EmptyData from "../../Components/EmptyData/EmptyData";
import MembershipsList from "../../Components/Memberships/MembershipsList.js";
import MembershipHistoryModal from "../../Components/Memberships/MembershipHistoryModal.js";
import CustomDropdown from "../../Components/DropDown/CustomDropdown.js";
import CustomPagination from "../../Components/CustomPagination/CustomPagination.js";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import Icons from "../../Constants/Icons.js";
import "react-datepicker/dist/react-datepicker.css";


const Memberships = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.isLoading);
  const [ambassadorData, setAmbassadorData] = useState([])
  const [deleteConfirmation, setDeleteConfirmation] = useState(false)
  const [selectedDeletePlan, setSelectedDeletePlan] = useState(null);
  const [historyData, setHistoryData] = useState([]);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const statusDropdownItem = ['All', 'Active', 'Cancelled', 'Expired'];
  const dateDropdownItem = ['All Time',
    'Today',
    'This Week',
    'This Month',
    'Last 6 Months'];
  const typeDropdownItem = [
    'All',
    'Pro',
    'Ambassador',
  ];
  const [statusSelect, setStatusSelect] = useState('Active')
  const [dateFilter, setDateFilter] = useState("All Time");
  const [typeFilter, setTypeFilter] = useState("All");
  const [initialPage, setInitialPage] = useState(0)
  const [totalCount, setTotalCount] = useState(0)
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [upgradeItem, setUpgradeItem] = useState(null);
  const [upgradeStartDate, setUpgradeStartDate] = useState(null);
  const [upgradeEndDate, setUpgradeEndDate] = useState(null);

  const closeUpgradeModal = () => {
    setShowUpgradeModal(false);
    setUpgradeItem(null);
    setUpgradeStartDate(null);
    setUpgradeEndDate(null);
  };

  const openUpgradeModal = (item) => {
    setUpgradeItem(item);
    setUpgradeStartDate(item.purchaseDate ? new Date(item.purchaseDate) : null);
    setUpgradeEndDate(item.expiryDate ? new Date(item.expiryDate) : null);
    setShowUpgradeModal(true);
  };

  const fetSubscriptionPlansData = async (
    selectedPage = initialPage,
    statusParam = statusSelect,
    typeParam = typeFilter,
    dateParam = dateFilter) => {
    try {
      dispatch(setLoadingTrue());
      const params = {
        offset: selectedPage + 1,
        limit: 10,
        status: statusParam.toUpperCase(),
        type: typeParam.toUpperCase(),
        dateFilter: dateParam,
      };
      const response = await apiCallGetActivatedPlan(params);
      setTotalCount(response?.totalCount ?? 0)
      setInitialPage(selectedPage ?? 0)
      setAmbassadorData(response.data);
    } catch (error) {
      console.error("Error fetching referral list:", error);
    } finally {
      dispatch(setLoadingFalse());
    }
  }

  useEffect(() => {
    fetSubscriptionPlansData(0);
  }, []);


  const handleCancel = async (item) => {
    dispatch(setLoadingTrue());
    try {
      await apiCallAmbassadorCancel({
        userId: item.userId?._id,
        planId: item.planId?._id,
      });

      fetSubscriptionPlansData(0);
    } catch (e) {
      console.log(e);
    } finally {
      dispatch(setLoadingFalse());
    }
  };

  const handleHistory = async (item) => {
    try {
      dispatch(setLoadingTrue());

      const res = await apiCallGetSubscriptionPlanHistory({
        userId: item.userId?._id,
      });

      if (res.success) {
        setHistoryData(res.data);
        setSelectedUser(item.userId);
        setShowHistoryModal(true);
      }
    } catch (e) {
      console.log(e);
    } finally {
      dispatch(setLoadingFalse());
    }
  };

  const handleDeletePlan = async () => {
    if (!selectedDeletePlan) return;

    dispatch(setLoadingTrue());
    try {
      await apiCallSubscriptionUpdatePlanStatus({
        planId: selectedDeletePlan._id,
        isDeleted: !selectedDeletePlan.isDeleted,
        sub_id: selectedDeletePlan.sub_id
      });
      setDeleteConfirmation(false);
      setSelectedDeletePlan(null);
      fetSubscriptionPlansData(0);
    } catch (error) {
      dispatch(setLoadingFalse());
      console.error(error);
    } finally {
      dispatch(setLoadingFalse());
    }
  };

  const confirmUpgradePlan = async () => {
    if (!upgradeItem) return;
    if (!upgradeStartDate || !upgradeEndDate) {
      alert("Please select both start and end dates.");
      return;
    }
    if (upgradeEndDate < upgradeStartDate) {
      alert("End date must be on or after the start date.");
      return;
    }

    const newPlanId = upgradeItem.planId._id;
    const startDate = format(upgradeStartDate, "yyyy-MM-dd");
    const endDate = format(upgradeEndDate, "yyyy-MM-dd");

    try {
      dispatch(setLoadingTrue());

      await apiUpgradeUserSubscription({
        userId: upgradeItem.userId?._id,
        newPlanId,
        productId: upgradeItem.productId,
        entitlementId: upgradeItem.entitlementId,
        startDate,
        endDate,
      });

      alert("Plan upgraded successfully");
      closeUpgradeModal();
      fetSubscriptionPlansData(0);
    } catch (err) {
      console.error("Upgrade failed", err);
      alert("Upgrade failed");
    } finally {
      dispatch(setLoadingFalse());
    }
  };

  return (
    <div>

      <div className='astrologers-list-parent padding-top-bottom'>
        <div className='custom-box-user'>
          <div className='custom-container-dropdown-div'>
            <CustomDropdown
              dropDownLabel={typeFilter}
              items={typeDropdownItem}
              color='blue'
              onSelect={(value) => {
                setTypeFilter(value);
                fetSubscriptionPlansData(0, statusSelect, value, dateFilter);
              }}
              customLabelStyle={{
                fontWeight: '400',
                color: 'white'
              }}
            />
          </div>

          {/* <div className='custom-container-dropdown-div'>
            <CustomDropdown
              dropDownLabel={statusSelect}
              items={statusDropdownItem}
              color='blue'
              onSelect={(value) => {
                setStatusSelect(value);
                fetSubscriptionPlansData(0, value, typeFilter, dateFilter);
              }}
              customLabelStyle={{
                fontWeight: '400',
                color: 'white'
              }}
            />
          </div> */}

          <div className='custom-container-dropdown-div'>
            <CustomDropdown
              dropDownLabel={dateFilter}
              items={dateDropdownItem}
              color='blue'
              onSelect={(value) => {
                setDateFilter(value);
                fetSubscriptionPlansData(0, statusSelect, typeFilter, value);
              }}
              customLabelStyle={{
                fontWeight: '400',
                color: 'white'
              }}
            />
          </div>


        </div>
      </div>

      <div className="Event-custom-style">
        <div className="lastWeekEndDiv Event-AlignSelf-stretch">
          <div className="user_title event-flex-container">
            Subscriptions
          </div>
          <div className="transparentWhite">
            <nav className="grid-cols grid_7 fontSize16WithoutFlex transparentWhite-padding">
              <div style={{ width: "22%" }} className="user_name">
                User
              </div>
              <div style={{ width: "20%" }} className="user_name">
                Plan
              </div>
              <div style={{ width: "18%" }} className="user_name">
                Status
              </div>
              <div style={{ width: "20%" }} className="user_name">
                Date              </div>
              <div style={{ width: "20%" }} className="user_name">
                Action
              </div>
            </nav>

            <MembershipsList
              data={ambassadorData}
              onCancel={handleCancel}
              onHistory={handleHistory}
              onUpgrade={openUpgradeModal}
            />
          </div>
        </div>
      </div>

      {showHistoryModal && (
        <MembershipHistoryModal
          data={historyData}
          user={selectedUser}
          onClose={() => setShowHistoryModal(false)}
        />
      )}

      {showUpgradeModal && upgradeItem && (
        <div
          className="modal-category"
          style={{
            zIndex: 999999,
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={(e) => e.target === e.currentTarget && closeUpgradeModal()}
        >
          <div
            className="modal-content"
            style={{
              backgroundColor: "rgba(6, 101, 228, 1)",
              borderRadius: "8px",
              padding: "24px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              width: "auto",
              maxWidth: "420px",
              color: "#fff",
              overflow: "visible",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 style={{ margin: "0 0 8px", fontSize: "18px" }}>Upgrade plan</h3>
            <p style={{ margin: "0 0 16px", fontSize: "13px", opacity: 0.95 }}>
              {upgradeItem.userId?.name} — {upgradeItem.planId?.title}
            </p>

            <div style={{ marginBottom: "16px" }}>
              <div style={{ fontSize: "12px", marginBottom: "6px", opacity: 0.9 }}>
                Start date
              </div>
              <DatePicker
                selected={upgradeStartDate}
                onChange={(date) => {
                  setUpgradeStartDate(date);
                  if (date && upgradeEndDate && upgradeEndDate < date) {
                    setUpgradeEndDate(date);
                  }
                }}
                dateFormat="yyyy-MM-dd"
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                onKeyDown={(e) => e.preventDefault()}
                popperClassName="membership-upgrade-datepicker-popper"
                customInput={
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      cursor: "pointer",
                      background: "rgba(255,255,255,0.15)",
                      padding: "10px 12px",
                      borderRadius: "6px",
                    }}
                  >
                    <img src={Icons.ic_date} style={{ height: "20px" }} alt="" />
                    <span style={{ fontSize: "14px" }}>
                      {upgradeStartDate
                        ? format(upgradeStartDate, "dd/MM/yyyy")
                        : "Select start date"}
                    </span>
                  </div>
                }
              />
            </div>

            <div style={{ marginBottom: "20px" }}>
              <div style={{ fontSize: "12px", marginBottom: "6px", opacity: 0.9 }}>
                End date
              </div>
              <DatePicker
                selected={upgradeEndDate}
                onChange={(date) => setUpgradeEndDate(date)}
                minDate={upgradeStartDate || undefined}
                dateFormat="yyyy-MM-dd"
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                onKeyDown={(e) => e.preventDefault()}
                popperClassName="membership-upgrade-datepicker-popper"
                customInput={
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      cursor: "pointer",
                      background: "rgba(255,255,255,0.15)",
                      padding: "10px 12px",
                      borderRadius: "6px",
                    }}
                  >
                    <img src={Icons.ic_date} style={{ height: "20px" }} alt="" />
                    <span style={{ fontSize: "14px" }}>
                      {upgradeEndDate
                        ? format(upgradeEndDate, "dd/MM/yyyy")
                        : "Select end date"}
                    </span>
                  </div>
                }
              />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "12px",
              }}
            >
              <button
                type="button"
                onClick={closeUpgradeModal}
                style={{
                  padding: "10px 16px",
                  backgroundColor: "#f0ad4e",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={confirmUpgradePlan}
                style={{
                  padding: "10px 16px",
                  backgroundColor: "#28a745",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Confirm upgrade
              </button>
            </div>
          </div>
          <style>{`
            .membership-upgrade-datepicker-popper {
              z-index: 10000000 !important;
            }
          `}</style>
        </div>
      )}

      {ambassadorData?.length == 0 && !isLoading && (
        <div className="empty-centered">
          <EmptyData />
        </div>
      )}

      {ambassadorData?.length !== 0 && (
        <div className='Custom-Pagination'>
          <CustomPagination
            pageCount={Math.ceil(totalCount / 10)}
            pageRangeDisplayed={3}
            initialPage={initialPage}
            marginPagesDisplayed={1}
            onPageChange={({ selected }) => {
              fetSubscriptionPlansData(selected)
            }}
          />
        </div>
      )}
      {deleteConfirmation && (
        <div
          className='modal-category'
          style={{
            zIndex: 999999,
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <div
            className='modal-content'
            style={{
              backgroundColor: 'rgba(6, 101, 228, 1)',
              borderRadius: '8px',
              padding: '20px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
              width: 'auto',
              maxWidth: '800px',
              textAlign: 'center',
              color: '#fff'
            }}
          >
            <p>Are you sure you want to delete this plan?</p>
            <br />
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '20px'
              }}
            >
              <button
                onClick={() => handleDeletePlan()}
                style={{
                  width: '100px',
                  padding: '10px',
                  backgroundColor: '#d9534f',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  transition: 'background-color 0.3s ease'
                }}
                onMouseEnter={e =>
                  (e.target.style.backgroundColor = '#c9302c')
                }
                onMouseLeave={e =>
                  (e.target.style.backgroundColor = '#d9534f')
                }
              >
                Yes
              </button>
              <button
                onClick={() => {
                  setDeleteConfirmation(false);
                  setSelectedDeletePlan(null);
                }}
                style={{
                  backgroundColor: '#f0ad4e',
                  width: '100px',
                  padding: '10px',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  transition: 'background-color 0.3s ease'
                }}
                onMouseEnter={e =>
                  (e.target.style.backgroundColor = '#ec971f')
                }
                onMouseLeave={e =>
                  (e.target.style.backgroundColor = '#f0ad4e')
                }
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Memberships;